import { gql } from '@apollo/client';

export type GetCSVFileRowAllColumnsType = {
  row: {
    id: string;
    createdAt: string;
    updatedAt: string;
    index: number;
    values: string[];
  };
};

export const GET_CSVFILE_ROW_ALLCOLUMNS = gql`
  query GetCSVFileRowAllColumns($input: CSVFileRowInput!) {
    row: getCSVFileRowAllColumns(input: $input) {
      id
      createdAt
      updatedAt
      index
      values
    }
  }
`;
